import React, {useState} from "react";
import {PrimaryButton, type ICommandBarItemProps} from "@fluentui/react";
import {useAuth} from "../../../../services/auth/hooks/useAuth";
import ConstructionStatus from "../../../../dto/construction/ConstructionStatus";

const useConstructionCommandBarItems = (
  constructionStatus: ConstructionStatus | undefined,
  handleShowDeleteDialogOpen: () => void,
  handleNewCalculationTrigger: () => Promise<void>,
  handleCalculationNavigationTrigger: () => void,
): ICommandBarItemProps[] => {
  const items: ICommandBarItemProps[] = [
    {
      key: "NewCalculation",
      onRender: () => (
        <PrimaryButton
          aria-label="New calculation"
          text="New calculation"
          iconProps={{
            iconName: "AddNotes",
          }}
          onClick={handleNewCalculation}
          disabled={isDisabled}
        />
      ),
    },
    {
      key: "calculateResults",
      onRender: () => (
        <PrimaryButton
          aria-label="View calculations"
          text="View calculations"
          iconProps={{iconName: "Calculator"}}
          onClick={handleCalculationNavigationTrigger}
          disabled={isDisabled}
        />
      ),
    },
    {
      key: "Delete",
      onRender: () => (
        <PrimaryButton
          aria-label="Delete construction"
          text="Delete"
          iconProps={{iconName: "Delete"}}
          onClick={handleShowDeleteDialogOpen}
          disabled={isDisabled}
        />
      ),
    },
  ];
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const {user} = useAuth();
  const isAllowedToTakeAction = user?.isAllowedToTakeAction();

  const handleNewCalculation = (): void => {
    setIsDisabled(true);
    try {
      void handleNewCalculationTrigger();
    } finally {
      setTimeout(() => {
        setIsDisabled(false);
      }, 2000);
    }
  };

  if (isAllowedToTakeAction && constructionStatus !== ConstructionStatus.Accepted) {
    return items;
  }

  return [items[1]];
};

export default useConstructionCommandBarItems;
